module.exports = new __parcel__URL__("decision.bd0dad97.png").toString();